import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import { ContentCopy as ContentCopyIcon } from '@vedmarket/ui-kit';

import { useDispatch } from 'react-redux';

import Calculator from '../calculator';

import {
  clearCalculationViewModeEditAttempt,
  useCalculationViewModeEditAttempt,
  useCloneCalculationForSupportMutation,
  useGetOrder,
} from '../../../api/calc';

import { useUserHasPermission } from '../../../api/auth';

import { useGetCalcIdFromRoute } from '../../../utils/hooks';
import AlertBottom from '../../common/alertBottom';

import './calculation-page.scss';

const CalculationPage = () => {

  const { t } = useTranslation();

  const { data: order } = useGetOrder();

  const orderId = useGetCalcIdFromRoute();
  const dispatch = useDispatch();

  const canViewCalculation = useUserHasPermission('staff.calculationView');
  const canCloneCalculation = useUserHasPermission('staff.calculationClone');

  const viewModeEditAttempt = useCalculationViewModeEditAttempt();
  const [ cloneCalculation ] = useCloneCalculationForSupportMutation();
  const [ isCloneErrorOpen, setIsCloneErrorOpen ] = useState(false);
  const [ cloneErrorMessage, setCloneErrorMessage ] = useState('');
  const [ isCloneSuccessOpen, setIsCloneSuccessOpen ] = useState(false);

  const handleCloneCalculation = () => {
    const calculationWindow = window.open('about:blank', '_blank');

    if (!calculationWindow) {
      return;
    }

    calculationWindow.opener = null;

    cloneCalculation(orderId).unwrap().then((data) => {
      const newNumber = data.num;

      if (newNumber) {
        setIsCloneSuccessOpen(true);

        if (!calculationWindow.closed) {
          calculationWindow.location.replace(`/cabinet/calculator/${newNumber}`);
        }
      } else {
        calculationWindow.close();
      }
    }).catch((error) => {
      calculationWindow.close();
      setCloneErrorMessage(error?.data?.detail || error?.data || t('errors__message__commonError'));
      setIsCloneErrorOpen(true);
    });
  };

  const cloneButton = (
    canCloneCalculation ? (
      <div className='calculation-page__actions'>
        <Button
          variant='outlined'
          className='calculation-page__clone-button'
          onClick={handleCloneCalculation}
          startIcon={<ContentCopyIcon />}
          fullWidth
        >
          {t('actions__text__cloneCalculationForSupport')}
        </Button>
      </div>
    ) : null
  );

  if (!canViewCalculation && !canCloneCalculation) {
    return null;
  }

  return (
    <div className='calculation-page'>
      <div className='calculation-page__content'>
        <Calculator
          title={order?.order_name}
          shouldHideTitle={!order?.order_name}
          rightPanelTopActions={cloneButton}
        />
      </div>
      <AlertBottom
        open={isCloneErrorOpen}
        onClose={() => setIsCloneErrorOpen(false)}
        message={cloneErrorMessage}
        isError
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        autoHideDuration={null}
      />
      <AlertBottom
        open={isCloneSuccessOpen}
        onClose={() => setIsCloneSuccessOpen(false)}
        message={t('actions__message__cloneCalculationForSupport')}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      />
      <AlertBottom
        open={viewModeEditAttempt}
        onClose={() => dispatch(clearCalculationViewModeEditAttempt())}
        message={t('calc__message__viewMode')}
        isError
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      />
    </div>
  );
};

export default CalculationPage;
